import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.21, 0.47, 0.32, 0.98]
      }
    }
  };
  return <section className="relative overflow-hidden bg-vita-cream py-24 md:py-32 lg:py-40" data-id="element-184">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} className="absolute -top-24 -right-24 w-96 h-96 bg-vita-green-light rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-186" />
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.5,
        ease: 'easeOut',
        delay: 0.2
      }} className="absolute -bottom-24 -left-24 w-80 h-80 bg-vita-orange-pale rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-187" />

        <svg className="absolute top-20 left-10 w-24 h-24 text-vita-green-sage opacity-20" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-188">
          <path d="M50 10C50 10 20 30 20 60C20 76.5 33.5 90 50 90C66.5 90 80 76.5 80 60C80 30 50 10 50 10Z" data-id="element-189" />
        </svg>
        <svg className="absolute bottom-20 right-20 w-32 h-32 text-vita-orange-light opacity-20 transform rotate-45" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-190">
          <circle cx="50" cy="50" r="40" data-id="element-191" />
        </svg>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10" data-id="element-192">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col items-center" data-id="element-193">
          <motion.h1 variants={itemVariants} className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-vita-green-deep leading-tight mb-6" data-id="element-194">
            Verstehen, was dein Körper dir sagen will
          </motion.h1>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-vita-text-muted max-w-2xl mb-10 leading-relaxed" data-id="element-195">
            Einfache Erklärungen zu Gesundheit, Vitaminen und Wohlbefinden.
            Begleite uns auf dem Weg zu einem natürlicheren Körpergefühl.
          </motion.p>

          <motion.div variants={itemVariants} data-id="element-196">
            <Link to="/artikel" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white bg-vita-green-deep rounded-full hover:bg-vita-green-medium hover:shadow-vita-hover transition-all duration-300 transform hover:-translate-y-1" data-id="element-197">
              Artikel entdecken
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}